import './header.scss';
import 'magnific-popup';
import MmenuLight from 'mmenu-light';

export default async () => {
	$( document ).on( 'click', 'a.scroll-to', function ( event ) {
		event.preventDefault();
		$( 'html, body' ).animate( {
			scrollTop: $( $( this ).attr( 'href' ) ).offset().top - 150,
		}, 500 );
	} );

	const menuHolder = document.querySelector( '#nav' );


	const newURL = `${window.location.protocol}//${window.location.host}/`;

	$( 'a[href*="#"]' )
	// Remove links that don't actually link to anything
		.not( '[href="#"]' )
		.not( '[href="#0"]' )
		.click( function ( event ) {
			// On-page links

			if (
				window.location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && window.location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				let target = $( this.hash );

				target = target.length ? target : $( this.hash.slice( 0 ) );
				// Does a scroll target exist?
				if ( target.length ) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$( 'html, body' ).animate( {
						scrollTop: target.offset().top - 75,
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						let $target = $( target );

						$target.focus();
						if ( $target.is( ':focus' ) ) { // Checking if the target was focused
							return false;
						} else {
							$target.attr( 'tabindex', '-1' ); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
					} );
				} else {
					let hash = $( this ).attr( 'href' ); // Get url

					// Console.log(hash);
					$( 'a' ).attr( 'href', newURL + hash );
				}
			}
		} );

	if ( menuHolder ) {
		const menu = new MmenuLight(
			menuHolder,
			'(max-width: 1023px)',
		);

		menu.navigation( {
			selected: 'is-active',
			title: 'Menu',
			theme: 'dark',
		} );

		const drawer = menu.offcanvas( {
			position: 'left',
		} );

		document.querySelector( 'a[href="#nav"]' ).addEventListener( 'click', ( event ) => {
			event.preventDefault();
			drawer.open();
		} );
	}

	$( '.popup-youtube' ).magnificPopup( {
		type: 'iframe',
		iframe: {
			patterns: {
				youtube: {
					index: 'youtube.com',
					id: 'v=',
					src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1',
				},
			},
		},
	} );
};
